import { QUERY_KEY_LIST_BALANCE } from '~/features/Balance/ListBalance'
import { useRefreshList } from '~/shared/ui/ScrollableList'

export const useRefreshPage = () => {
  const { refreshList } = useRefreshList(QUERY_KEY_LIST_BALANCE)

  const refreshPage = async () => {
    await refreshList()
  }

  return { refreshPage }
}
